import React, { useRef, memo } from 'react';
import { LOADING_CIRCLE } from 'common/utils/constants';
import './ActionButton.css';
import { v4 } from 'uuid';

const ActionButton = ({
  disabled,
  loading,
  onClick,
  title,
  hoveredMessage,
  backgroundColor,
  textColor,
  hoveredBackgroundColor,
  customStyles
}) => {
  const buttonIdRef = useRef(v4());

  const handleMouseOver = () => {
    const el = document.getElementById(buttonIdRef.current);
    el.style.background = hoveredBackgroundColor;
  };

  const handleMouseLeave = () => {
    const el = document.getElementById(buttonIdRef.current);
    el.style.background = backgroundColor;
  };

  const handleClick = () => {
    if (!disabled || !loading) {
      onClick();
    }
  };

  const buttonStyles = {
    ...customStyles,
    backgroundColor,
    color: textColor
  };

  return (
    <button
      id={buttonIdRef.current}
      className="ActionButton"
      style={buttonStyles}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      disabled={disabled || loading}
      onClick={handleClick}
      title={hoveredMessage}
    >
      {loading ? LOADING_CIRCLE : <span>{title}</span>}
    </button>
  );
};

export default memo(ActionButton);
